'use strict'
import Cookie from 'js-cookie'
import alert from './alert'

export default ($container) => {
	const showAlert = alert($container)

	try {
		const encodedNotifications = Cookie.get('is_notifications')

		if (!encodedNotifications) return

		const notifications = encodedNotifications
			.split('|')
			.map(decodeURIComponent)
			.map(entry => {
				const parts = entry.split(':');
				return {
					message: parts[0].replace(/\+/g, ' '),
					type: parts[1] || '',
					persistent: true
				}
			})

		notifications.forEach(showAlert)

		Cookie.remove('is_notifications')

	} catch (e) {
		console.log(e);
	}
}
